import moment from "moment";

// The API stores calculation_date as the UTC calendar day (Carbon::now() with
// the app timezone set to UTC). Between local midnight and 00:00 UTC, a
// timezone ahead of UTC is already on the next calendar day. Sending that
// local day is saved by GET /option-rows and Push to Team Run then 422s.

const DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})(?:$|[ T])/;

export function utcToday() {
  return new Date().toISOString().slice(0, 10);
}

// A calendar day the user picked, or a UTC timestamp from the API, stays that
// YYYY-MM-DD. Date-only strings are not parsed with Date: `new Date("YYYY-MM-DD")`
// is UTC midnight and shifts to the previous local day west of UTC.
export function calendarDate(value) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (/[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed.toISOString().slice(0, 10);
  }

  const match = trimmed.match(DATE_PREFIX);
  return match ? match[1] : null;
}

export function pricerWorkingDate(value) {
  return calendarDate(value) ?? utcToday();
}

export function isUtcToday(value) {
  const day = calendarDate(value);
  return day != null && day === utcToday();
}

// Picker value for an already-chosen YYYY-MM-DD. UTC parse, then keep those
// wall-clock digits so the calendar cell does not move across midnight.
export function utcCalendarMoment(value) {
  const day = calendarDate(value);
  if (!day) return null;
  const timeMatch =
    typeof value === "string"
      ? value.trim().match(/(?:[ T])(\d{2}:\d{2}:\d{2})/)
      : null;
  if (timeMatch) {
    return moment
      .utc(`${day} ${timeMatch[1]}`, "YYYY-MM-DD HH:mm:ss", true)
      .local(true);
  }
  return moment.utc(day, "YYYY-MM-DD", true).local(true);
}

// "Now" / "Today" inside a calculation-date picker: UTC clock, same digits.
export function utcNowMoment() {
  const iso = new Date().toISOString();
  return moment
    .utc(`${iso.slice(0, 10)} ${iso.slice(11, 19)}`, "YYYY-MM-DD HH:mm:ss", true)
    .local(true);
}
